"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutConfig = void 0;
const helpers_1 = require("../../shared/helpers");
const getLayoutConfig = (stimulus, translations, mediaAssets) => {
    const { answer, distractors, trialType } = stimulus;
    const defaultConfig = JSON.parse(JSON.stringify(helpers_1.DEFAULT_LAYOUT_CONFIG));
    const stimItem = (0, helpers_1.convertItemToString)(stimulus.item);
    defaultConfig.isPracticeTrial = stimulus.assessmentStage === 'practice_response';
    defaultConfig.isInstructionTrial = stimulus.trialType === 'instructions';
    defaultConfig.showStimImage = false;
    defaultConfig.stimText = {
        value: stimItem,
        displayValue: undefined,
    };
    if (!defaultConfig.isInstructionTrial) {
        const mappedDistractors = (0, helpers_1.mapDistractorsToString)(distractors);
        const prepChoices = (0, helpers_1.prepareChoices)(answer.toString(), mappedDistractors, 'yes', trialType);
        defaultConfig.prompt.enabled = false;
        defaultConfig.isImageButtonResponse = false;
        defaultConfig.classOverrides.buttonClassList = ['secondary--wide'];
        defaultConfig.response = {
            target: prepChoices.target,
            displayValues: prepChoices.choices,
            values: prepChoices.originalChoices,
            targetIndex: prepChoices.correctResponseIdx,
        };
        defaultConfig.stimText = {
            value: stimItem,
            displayValue: stimItem,
        };
    }
    else {
        defaultConfig.classOverrides.buttonClassList = ['primary'];
    }
    const messages = (0, helpers_1.validateLayoutConfig)(defaultConfig, mediaAssets, translations, stimulus);
    return {
        itemConfig: defaultConfig,
        errorMessages: messages,
    };
};
exports.getLayoutConfig = getLayoutConfig;
